'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _requestAppointmentModal = require('../../src/styles/request-appointment-modal.scss');

var _requestAppointmentModal2 = _interopRequireDefault(_requestAppointmentModal);

require('../../src/styles/external.scss');

var _doctifyModal = require('./doctify-modal');

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { FormattedMessage } from 'react-intl';
// import messages from '../lang/default-messages';

var spireTitles = ['Admiral', 'Air Chief Marshal', 'Air Marshal', 'Air Vice Marshal', 'Archdeacon', 'Baron', 'Baroness', 'Bishop', 'Brigadier', 'C Sgt', 'Canon', 'Captain', 'Circuit Judge', 'Colonel', 'Commander', 'Commodore', 'Count', 'Countess', 'Dame', 'Dowager Baroness', 'Dowager Countess', 'Dowager Duchess', 'Dowager Marchioness', 'Dowager Viscountess', 'Dr', 'Duchess', 'Duke', 'Earl', 'Excellency', 'Execs Of', 'Father', 'Flight Lieutenant', 'General', 'Group Captain', 'His All Holiness', 'His Beatitude', 'His Eminence', 'His Grace', 'His Holiness', 'His Most Eminent Highness', 'Honourable', 'Honourable Judge', 'Judge', 'Justice', 'Justice of the Peace', 'Lady', 'Lieutenant', 'Lieutenant Colonel', 'Lieutenant Commander', 'Lieutenant General', 'Lord', 'Madam', 'Major', 'Major General', 'Marchioness', 'Marquess', 'Marshal', 'Master', 'Miss', 'Monsignor', 'Mr', 'Mrs', 'Ms', 'MX', 'My Lady', 'Priest', 'Prince', 'Princess', 'Prof', 'Professor', 'Rabbi', 'Rear Admiral', 'Rev Canon', 'Rev Dr', 'Reverend', 'Right Honourable', 'Rt Hon Lord', 'Sir', 'Sister', 'Squadron Leader', 'Sub Lieutenant', 'The Honourable', 'The Honourable Mrs', 'The Late', 'The Most Honourable', 'Venerable', 'Very Reverend Father', 'Vice Admiral', 'Vice Chancellor', 'Viscount', 'Viscountess', 'Wing Commander'];

/**
 * @param {string} num - any number as a string
 * @param {number} length - required number length
 * return true if length of provided @num equal to @length
 */
var validateNumberByLength = function validateNumberByLength(num, length) {
  return typeof num === 'string' && num && num.match(/^\d+$/g) && num.length === length;
};
var validateNumberByGreaterLength = function validateNumberByGreaterLength(num, length) {
  return typeof num === 'string' && num && num.match(/^\d+$/g) && num.length >= length;
};

var PHONE_NUMBER_LENGTH = 11;
var CLAIM_NUMBER_MIN_LENGTH = 7;
var POLICY_NUMBER_LENGTH = 10;

var validPhone = function validPhone(num) {
  return num && num[0] === "0" && validateNumberByLength(num, PHONE_NUMBER_LENGTH);
};
var validClaimNumber = function validClaimNumber(num) {
  return validateNumberByGreaterLength(num, CLAIM_NUMBER_MIN_LENGTH);
};
var validPolicyNumber = function validPolicyNumber(num) {
  return validateNumberByLength(num, POLICY_NUMBER_LENGTH);
};

var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var validateBirthday = function validateBirthday(birthday) {
  return !(birthday.substring(0, 2) === '00') && !(birthday.substring(3, 6) === 'xxx') && !(birthday.substring(7, 11) === '0000') ? true : false; //eslint-disable-line
};

var isFormValid = function isFormValid(props) {
  //address required for external bookings
  if (props.requestData.request_type === 'bmi' || props.requestData.request_type === 'ramsay' || props.requestData.request_type === 'spire') {
    if (!(props.requestData.addressLine && props.requestData.addressLine.length > 3 && props.requestData.addressCity && props.requestData.addressCity.length > 3 && props.requestData.addressPostcode && props.requestData.addressPostcode.length > 5)) {
      return false;
    }
  }

  return props.requestData && emailRegex.test(props.requestData.email) && props.requestData.firstname && props.requestData.firstname.length > 0 && props.requestData.lastname && props.requestData.lastname.length > 0 && props.requestData.patient_claim_number && props.requestData.patient_claim_number.length > 0 && props.requestData.patient_policy_number && props.requestData.patient_policy_number.length > 0 && props.requestData.practice && (props.requestData.availability_id && props.requestData.attributes.gender && props.requestData.attributes.gender.length || !props.requestData.availability_id) && validPhone(props.requestData.phone) && validClaimNumber(props.requestData.patient_claim_number) && validPolicyNumber(props.requestData.patient_policy_number) && props.agreeWithTerms === true;
};

var transformRequestData = function transformRequestData(requestData, network) {
  if (network) {
    requestData = (0, _extends3.default)({}, requestData, {
      message: 'THIS IS A VITALITY ' + network + ' NETWORK BOOKING ' + requestData.message
    });
  }

  if (requestData.request_type === 'bmi' || requestData.request_type === 'ramsay' || requestData.request_type === 'spire') {
    var dateSplited = requestData.attributes.birthdate.split('-');
    return (0, _assign2.default)({}, requestData, (0, _extends3.default)({}, requestData, {
      attributes: (0, _extends3.default)({}, requestData.attributes, {
        birthdate: dateSplited[2] + '-' + dateSplited[1] + '-' + dateSplited[0]
      })
    }));
  }

  return requestData;
};

var days = [];
var months = [];
var monthsBmi = [];
var years = [];

var MAX_DAYS_IN_MONTH = 31;
var MINIMUM_AGE = 18;
var MONTHS_IN_YEAR = 12;
var YEARS_TO_DISPLAY = 100;

for (var i = 1; i <= MAX_DAYS_IN_MONTH; i++) {
  days.push(_react2.default.createElement(
    'option',
    { key: 'day' + i, value: i },
    i
  ));
}

var MONTH_VALUES = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
var MONTH_VALUES_BMI = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
for (var _i = 0; _i < MONTH_VALUES.length; _i++) {
  months.push(_react2.default.createElement(
    'option',
    { key: 'month' + _i, value: MONTH_VALUES[_i] },
    _moment2.default.months(_i)
  ));
  monthsBmi.push(_react2.default.createElement(
    'option',
    { key: 'month' + _i, value: MONTH_VALUES_BMI[_i] },
    _moment2.default.months(_i)
  ));
}

for (var _i2 = (0, _moment2.default)().subtract(MINIMUM_AGE, 'years').get('year'); _i2 >= (0, _moment2.default)().get('year') - YEARS_TO_DISPLAY; _i2--) {
  years.push(_react2.default.createElement(
    'option',
    { key: 'year' + _i2, value: _i2 },
    _i2
  ));
}

// Several modals use all this functionality. Should probably be a library within this repo somewhere.
// Date dropdown section, validation methods etc.

var RequestAppointmentModal = function RequestAppointmentModal(props) {
  var isPhoneInvalid = props.submitAttempted && !validPhone(props.requestData.phone);
  var isClaimNumberInvalid = props.submitAttempted && !validClaimNumber(props.requestData.patient_claim_number);
  var isPolicyNumberInvalid = props.submitAttempted && !validPolicyNumber(props.requestData.patient_policy_number);
  return _react2.default.createElement(
    _doctifyModal2.default,
    (0, _extends3.default)({}, props, {
      className: props.className,
      bodyStyles: _requestAppointmentModal2.default.body,
      title: !props.submitSuccessful ? 'Request appointment - in 60 seconds' : '',
      header: !props.submitSuccessful ? props.requestData.request_type === 'bmi' || props.requestData.request_type === 'ramsay' || props.requestData.request_type === 'spire' ? _react2.default.createElement(
        'span',
        null,
        'Request Appointment ',
        _react2.default.createElement(
          'span',
          { className: _requestAppointmentModal2.default.headerSmall + ' ' + _requestAppointmentModal2.default['vitality-primary'] },
          '- in less than 60 seconds'
        )
      ) : _react2.default.createElement(
        'span',
        null,
        'Send a message to ',
        props.specialistName,
        ' to request an appointment'
      ) : _react2.default.createElement(
        'span',
        { className: _requestAppointmentModal2.default.headerLarge + ' ' + _requestAppointmentModal2.default['vitality-primary'] },
        _react2.default.createElement('i', {
          className: 'ion-ios-checkmark-outline' }),
        'You\'re Booked!'
      ) }),
    props.account.specialist && props.account.specialist.account && props.account.specialist.account.id && _react2.default.createElement(
      'div',
      { className: _requestAppointmentModal2.default.loggedInAsSpecialist },
      _react2.default.createElement(
        'div',
        { className: _requestAppointmentModal2.default.errorText },
        'You appear to be logged in as a Specialist. Accounts of this type cannot request appointments. Please log into a patient account to proceed.'
      ),
      _react2.default.createElement(
        'button',
        { className: 'btn solid ' + _requestAppointmentModal2.default.btnSubmit,
          type: 'button',
          onClick: function onClick() {
            props.closeModal();
          } },
        'Close'
      )
    ) || _react2.default.createElement(
      'form',
      { className: '' + (props.submitAttempted ? _requestAppointmentModal2.default.submitAttempted : '') },
      !props.submitSuccessful && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: _requestAppointmentModal2.default.specialistHeader },
          _react2.default.createElement(
            'h4',
            { className: _requestAppointmentModal2.default.subtitle },
            'Specialist'
          ),
          _react2.default.createElement(
            'p',
            { className: _requestAppointmentModal2.default.requiredField },
            '* indicates required field'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-pulse' }),
              _react2.default.createElement('input', { className: 'form-control ' + _requestAppointmentModal2.default.formControl,
                defaultValue: props.specialistName,
                readOnly: true
              })
            )
          ),
          props.availability ? _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement('input', { className: 'form-control ' + _requestAppointmentModal2.default.formControl,
              defaultValue: props.availability.practice.name,
              readOnly: true
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement(
                'select',
                { className: 'form-control ' + _requestAppointmentModal2.default.noIcon + ' ' + _requestAppointmentModal2.default.formControl,
                  defaultValue: '',
                  onChange: function onChange(event) {
                    props.onPracticeChange(event.target.value);
                  },
                  required: true },
                _react2.default.createElement(
                  'option',
                  { disabled: true, value: '' },
                  'Select a practice *'
                ),
                props.practices && props.practices.map(function (practice) {
                  return _react2.default.createElement(
                    'option',
                    { key: practice.id, value: practice.id },
                    practice.name
                  );
                })
              ),
              _react2.default.createElement('i', { className: 'ion-ios-arrow-down ' + _requestAppointmentModal2.default.listArrow })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipPractice + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerPractice },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' This is your selected practice for the listed specialist.'
            )
          )
        ),
        _react2.default.createElement(
          'h4',
          { className: _requestAppointmentModal2.default.yourDetails },
          'Your details'
        ),
        props.requestData.request_type === 'spire' && _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement(
                'select',
                { className: 'form-control ' + _requestAppointmentModal2.default.noIcon + ' ' + _requestAppointmentModal2.default.formControl,
                  defaultValue: props.requestData.attributes.title || '',
                  onChange: function onChange(event) {
                    props.onTitleChange(event.target.value);
                    props.requestData.title = event.target.value;
                  },
                  required: true },
                _react2.default.createElement(
                  'option',
                  { disabled: true, value: '' },
                  'Title *'
                ),
                spireTitles.map(function (title) {
                  return _react2.default.createElement(
                    'option',
                    { key: title, value: title },
                    title
                  );
                })
              ),
              _react2.default.createElement('i', { className: 'ion-ios-arrow-down ' + _requestAppointmentModal2.default.listArrow })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipGender + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerGender },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' We collect your title so we know how to address you.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-contact' }),
              _react2.default.createElement('input', { className: 'form-control ' + _requestAppointmentModal2.default.formControl,
                defaultValue: props.patient.firstname || props.requestData.firstname,
                placeholder: 'First name *',
                onChange: function onChange(event) {
                  props.onFirstNameChange(event.target.value);
                },
                required: true
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipFirstName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerFirstName },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' We collect your first name so we know how to address you.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-contact' }),
              _react2.default.createElement('input', { className: 'form-control ' + _requestAppointmentModal2.default.formControl,
                defaultValue: props.patient.lastname || props.requestData.lastname,
                placeholder: 'Last name *',
                onChange: function onChange(event) {
                  props.onLastNameChange(event.target.value);
                },
                required: true
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipLastName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerLastName },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' We collect your last name so we know how to address you.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-email-outline' }),
              _react2.default.createElement('input', {
                className: 'form-control ' + _requestAppointmentModal2.default.formControl + ' ' + (props.submitAttempted && !emailRegex.test(props.requestData.email) ? _requestAppointmentModal2.default.validationError : ''),
                defaultValue: props.patient.email || props.requestData.email,
                placeholder: 'Email *',
                onChange: function onChange(event) {
                  props.onEmailChange(event.target.value);
                },
                required: true
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipEmail + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerEmail },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' We use your email address to contact you about your requested appointment.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-telephone' }),
              _react2.default.createElement('input', {
                className: 'form-control ' + _requestAppointmentModal2.default.formControl + ' ' + (isPhoneInvalid ? _requestAppointmentModal2.default.validationError : ''),
                placeholder: 'Phone *',
                defaultValue: props.requestData.attributes.phone || '',
                onChange: function onChange(event) {
                  props.onPhoneChange(event.target.value);
                },
                required: true
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipNumber + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerNumber },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' We use your number to contact you about your requested appointment.'
            ),
            isPhoneInvalid ? _react2.default.createElement(
              'span',
              { className: _requestAppointmentModal2.default.validationErrorMessage },
              'Please enter a valid UK phone number, this should be 11 digits long starting with 0'
            ) : null
          )
        ),
        (!props.patient.email || props.requestData.request_type === 'bmi' || props.requestData.request_type === 'ramsay' || props.requestData.request_type === 'spire') && _react2.default.createElement(
          'div',
          {
            className: 'form-group ' + _requestAppointmentModal2.default.formGroup + ' ' + (props.requestData.request_type === 'bmi' || props.requestData.request_type === 'ramsay' || props.requestData.request_type === 'spire' ? '' : _requestAppointmentModal2.default.hidden) },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement(
                'select',
                { className: 'form-control ' + _requestAppointmentModal2.default.noIcon + ' ' + _requestAppointmentModal2.default.formControl,
                  defaultValue: props.requestData.attributes.gender || '',
                  onChange: function onChange(event) {
                    props.onGenderChange(event.target.value);
                    props.requestData.gender = event.target.value;
                  },
                  required: true },
                _react2.default.createElement(
                  'option',
                  { disabled: true, value: '' },
                  'Gender *'
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'm' },
                  'Male'
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'f' },
                  'Female'
                )
              ),
              _react2.default.createElement('i', { className: 'ion-ios-arrow-down ' + _requestAppointmentModal2.default.listArrow })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipGender + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerGender },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' We use your gender to tailor your Doctify service.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
              _react2.default.createElement('input', {
                className: 'form-control ' + _requestAppointmentModal2.default.formControl + ' ' + (isClaimNumberInvalid ? _requestAppointmentModal2.default.validationError : ''),
                placeholder: 'Claim number *',
                value: props.requestData.patient_claim_number,
                onChange: function onChange(event) {
                  props.onClaimNumberChange(event.target.value);
                },
                required: true
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipFirstName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerFirstName },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' This is used to match your claim to your appointment.'
            ),
            isClaimNumberInvalid ? _react2.default.createElement(
              'span',
              { className: _requestAppointmentModal2.default.validationErrorMessage },
              'Please enter a valid Vitality Claim number, this should be 7 digits or more'
            ) : null
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
              _react2.default.createElement('input', {
                className: 'form-control ' + _requestAppointmentModal2.default.formControl + ' ' + (isPolicyNumberInvalid ? _requestAppointmentModal2.default.validationError : ''),
                placeholder: 'Membership number *',
                value: props.requestData.patient_policy_number,
                onChange: function onChange(event) {
                  props.onPolicyNumberChange(event.target.value);
                },
                required: true
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipLastName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerLastName },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' This is used to identify your policy.'
            ),
            isPolicyNumberInvalid ? _react2.default.createElement(
              'span',
              { className: _requestAppointmentModal2.default.validationErrorMessage },
              'Please enter a valid Vitality Membership Number, this should be 10 digits long'
            ) : null
          )
        ),
        !props.patient.email && _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.dateContainer },
          _react2.default.createElement(
            'label',
            { className: _requestAppointmentModal2.default.smallSubheader },
            'Date of Birth *'
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12' },
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.formGroup + ' ' + _requestAppointmentModal2.default.inputContainerDob },
              _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-4 ' + _requestAppointmentModal2.default.dateInput },
                  _react2.default.createElement(
                    'div',
                    { className: 'df-input-group' },
                    _react2.default.createElement(
                      'select',
                      { className: 'form-control ' + _requestAppointmentModal2.default.noIcon + ' ' + _requestAppointmentModal2.default.formControl,
                        defaultValue: props.availability && !props.requestData.attributes.birthdate.split('-')[0].includes('00') ? props.requestData.attributes.birthdate.split('-')[0] : '',
                        onChange: function onChange(event) {
                          props.onBirthdateDayChange(event.target.value);
                        },
                        required: true },
                      _react2.default.createElement(
                        'option',
                        { disabled: true, value: '' },
                        'Day *'
                      ),
                      days.map(function (day) {
                        return day;
                      })
                    ),
                    _react2.default.createElement('i', { className: 'ion-ios-arrow-down ' + _requestAppointmentModal2.default.listArrow })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-4 ' + _requestAppointmentModal2.default.dateInput },
                  _react2.default.createElement(
                    'div',
                    { className: 'df-input-group' },
                    _react2.default.createElement(
                      'select',
                      { className: 'form-control ' + _requestAppointmentModal2.default.noIcon + ' ' + _requestAppointmentModal2.default.formControl,
                        defaultValue: props.availability && !props.requestData.attributes.birthdate.split('-')[1].includes('xxx') ? props.requestData.attributes.birthdate.split('-')[1] : '',
                        onChange: function onChange(event) {
                          props.onBirthdateMonthChange(event.target.value);
                        },
                        required: true },
                      _react2.default.createElement(
                        'option',
                        { disabled: true, value: '' },
                        'Month *'
                      ),
                      props.requestData.request_type === 'bmi' || props.requestData.request_type === 'ramsay' || props.requestData.request_type === 'spire' ? monthsBmi.map(function (month) {
                        return month;
                      }) : months.map(function (month) {
                        return month;
                      })
                    ),
                    _react2.default.createElement('i', { className: 'ion-ios-arrow-down ' + _requestAppointmentModal2.default.listArrow })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-4 ' + _requestAppointmentModal2.default.dateInput },
                  _react2.default.createElement(
                    'div',
                    { className: 'df-input-group' },
                    _react2.default.createElement(
                      'select',
                      { className: 'form-control ' + _requestAppointmentModal2.default.noIcon + ' ' + _requestAppointmentModal2.default.formControl,
                        defaultValue: props.availability && !props.requestData.attributes.birthdate.split('-')[2].includes('0000') ? props.requestData.attributes.birthdate.split('-')[2] : '',
                        onChange: function onChange(event) {
                          props.onBirthdateYearChange(event.target.value);
                        },
                        required: true },
                      _react2.default.createElement(
                        'option',
                        { disabled: true, value: '' },
                        'Year *'
                      ),
                      years.map(function (year) {
                        return year;
                      })
                    ),
                    _react2.default.createElement('i', { className: 'ion-ios-arrow-down ' + _requestAppointmentModal2.default.listArrow })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12 ' + _requestAppointmentModal2.default.dobDisclaimer },
                  'Patient must be over 18 years of age'
                )
              )
            )
          ),
          _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipDob + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
          _react2.default.createElement(
            'div',
            { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerDob },
            _react2.default.createElement(
              'strong',
              null,
              'Why?'
            ),
            ' Your date of birth helps us to provide age-appropriate settings. We won\'t display it.'
          )
        ),
        (props.requestData.request_type === 'bmi' || props.requestData.request_type === 'ramsay' || props.requestData.request_type === 'spire') && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            { className: _requestAppointmentModal2.default.smallSubheader },
            'Address'
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-12' },
              _react2.default.createElement(
                'div',
                { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainerFull },
                _react2.default.createElement('i', { className: 'ion-ios-location' }),
                _react2.default.createElement('input', {
                  className: 'form-control ' + _requestAppointmentModal2.default.formControl + ' ' + (props.submitAttempted && props.requestData.addressLine.length < 4 ? _requestAppointmentModal2.default.validationError : ''),
                  placeholder: 'Address line',
                  value: props.requestData.addressLine,
                  onChange: function onChange(event) {
                    props.onAddressLineChange(event.target.value);
                  },
                  required: true
                })
              ),
              _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipFirstName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
              _react2.default.createElement(
                'div',
                { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerFirstName },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Why?'
                ),
                ' Address line'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-12 col-md-6' },
              _react2.default.createElement(
                'div',
                { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
                _react2.default.createElement('i', { className: 'ion-ios-location-outline' }),
                _react2.default.createElement('input', {
                  className: 'form-control ' + _requestAppointmentModal2.default.formControl + ' ' + (props.submitAttempted && props.requestData.addressCity.length < 4 ? _requestAppointmentModal2.default.validationError : ''),
                  placeholder: 'City',
                  value: props.requestData.addressCity,
                  onChange: function onChange(event) {
                    props.onAddressCityChange(event.target.value);
                  },
                  required: true
                })
              ),
              _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipFirstName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
              _react2.default.createElement(
                'div',
                { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerFirstName },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Why?'
                ),
                ' City'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-12 col-md-6' },
              _react2.default.createElement(
                'div',
                { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
                _react2.default.createElement('i', { className: 'ion-ios-location-outline' }),
                _react2.default.createElement('input', {
                  className: 'form-control ' + _requestAppointmentModal2.default.formControl + ' ' + (props.submitAttempted && props.requestData.addressPostcode.length < 6 ? _requestAppointmentModal2.default.validationError : ''),
                  placeholder: 'Post code',
                  value: props.requestData.addressPostcode,
                  onChange: function onChange(event) {
                    props.onAddressPostcodeChange(event.target.value);
                  },
                  required: true
                })
              ),
              _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipLastName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
              _react2.default.createElement(
                'div',
                { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerLastName },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Why?'
                ),
                ' Post code'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-12' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group textarea ' + _requestAppointmentModal2.default.inputContainerTextarea },
              _react2.default.createElement('textarea', { className: 'form-control ' + _requestAppointmentModal2.default.visitReasonInput + ' ' + _requestAppointmentModal2.default.formControl,
                placeholder: 'Reason for visit',
                value: props.requestData.message,
                onChange: function onChange(event) {
                  props.onVisitReasonChange(event.target.value);
                }
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipReason + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerReason },
              _react2.default.createElement(
                'strong',
                null,
                'Why?'
              ),
              ' Let us know why you are visiting so that the specialist can better serve you.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.formGroup },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12 col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'df-input-group ' + _requestAppointmentModal2.default.inputContainer },
              _react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
              _react2.default.createElement('input', { className: 'form-control ' + _requestAppointmentModal2.default.formControl,
                placeholder: 'Agent ID',
                value: props.requestData.employeeId,
                onChange: function onChange(event) {
                  props.onEmployeeIdChange(event.target.value);
                }
              })
            ),
            _react2.default.createElement('i', { className: _requestAppointmentModal2.default.tooltipFirstName + ' ' + _requestAppointmentModal2.default.tooltipIcon + ' ion-information-circled' }),
            _react2.default.createElement(
              'div',
              { className: _requestAppointmentModal2.default.modalTooltipContainer + ' ' + _requestAppointmentModal2.default.tooltipContainerFirstName },
              'This optional field should only be filled in by Vitality agents'
            )
          )
        ),
        !props.submitSuccessful && _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.agreeToPrivacyTerms },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12' },
            _react2.default.createElement(
              'div',
              {
                className: _requestAppointmentModal2.default.agreeCheckboxContainer + ' ' + (props.submitAttempted && !props.agreeWithTerms && _requestAppointmentModal2.default.validationError || '') },
              _react2.default.createElement('input', {
                id: 'privacy-terms',
                type: 'checkbox'
              }),
              _react2.default.createElement(
                'label',
                {
                  onClick: function onClick() {
                    return props.onTogglePolicyTermsAgreement(!props.agreeWithTerms);
                  },
                  htmlFor: 'privacy-terms'
                },
                'I agree to the ',
                _react2.default.createElement(
                  'a',
                  { href: '/terms-and-conditions' },
                  'Terms and Conditions'
                ),
                ' and ',
                _react2.default.createElement(
                  'a',
                  {
                    href: '/privacy-policy' },
                  'Privacy Policy'
                ),
                ' *'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group ' + _requestAppointmentModal2.default.action },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12' },
            _react2.default.createElement(
              'button',
              { className: 'btn solid ' + _requestAppointmentModal2.default.btnSubmit,
                style: props.loading ? { 'background-color': 'lightgray' } : {},
                type: 'button',
                disabled: props.loading,
                onClick: function onClick() {
                  if (isFormValid(props)) {
                    if (!props.patient.email) {
                      if (props.requestData && props.requestData.attributes && validateBirthday(props.requestData.attributes.birthdate)) {
                        if (props.requestData.create_subscription) {
                          props.createSubscription({
                            email_address: props.requestData.email
                          });
                        }
                        var _requestData = transformRequestData(props.requestData, props.network);
                        props.submitAppointmentRequestSend();
                        props.submitAppointmentRequest(_requestData, props.patient.auth_token, function () {
                          return props.updateAvailabilities();
                        }).then(function () {
                          (0, _doctifyUtils.fireGTMevent)('lead_submit_patient');
                        });
                        return;
                      } else {
                        props.validationError();
                        return;
                      }
                    } else {
                      var _requestData2 = transformRequestData(props.requestData, props.network);
                      props.submitAppointmentRequestSend();
                      props.submitAppointmentRequest(_requestData2, props.patient.auth_token, function () {
                        return props.updateAvailabilities();
                      }).then(function () {
                        (0, _doctifyUtils.fireGTMevent)('lead_submit_patient');
                      });
                      return;
                    }
                  } else {
                    props.validationError();
                  }
                } },
              'Submit'
            ),
            _react2.default.createElement(
              'button',
              { className: 'btn specialist ' + _requestAppointmentModal2.default.btnCancel,
                type: 'button',
                onClick: function onClick() {
                  props.closeModal();
                } },
              'Cancel'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _requestAppointmentModal2.default.footnotes },
          _react2.default.createElement(
            'p',
            null,
            'By submitting this contact form, ',
            props.specialistName,
            ' will be informed about your request for an appointment. To enable the specialist to reach out to you we will share your contact details as per your Doctify profile.'
          )
        )
      ),
      props.submitSuccessful && _react2.default.createElement(
        'div',
        { className: _requestAppointmentModal2.default.submitSuccessScreen },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Thank you for booking \u2013 a confirmation email is on its way to you.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'It\u2019s important that you don\u2019t book another time slot with the same doctor, for this claim \u2013 as you\'re already booked in.'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { className: 'btn solid ' + _requestAppointmentModal2.default.btnSubmit,
              type: 'button',
              onClick: function onClick() {
                props.closeModal();
              } },
            'Close'
          )
        )
      )
    )
  );
};

RequestAppointmentModal.propTypes = {
  practices: require('react').PropTypes.any.isRequired,
  patient: require('react').PropTypes.object.isRequired,
  requestData: require('react').PropTypes.object.isRequired,
  specialistName: require('react').PropTypes.any.isRequired,
  className: require('react').PropTypes.any,
  accountType: require('react').PropTypes.any.isRequired,
  submitAttempted: require('react').PropTypes.any.isRequired,
  submitInProgress: require('react').PropTypes.any.isRequired,
  submitSuccessful: require('react').PropTypes.any.isRequired,
  account: require('react').PropTypes.object.isRequired,
  agreeWithTerms: require('react').PropTypes.bool.isRequired,
  closeModal: require('react').PropTypes.func.isRequired,
  onCreateSubscriptionToggle: require('react').PropTypes.func.isRequired,
  onPracticeChange: require('react').PropTypes.func.isRequired,
  onFirstNameChange: require('react').PropTypes.func.isRequired,
  onLastNameChange: require('react').PropTypes.func.isRequired,
  onEmailChange: require('react').PropTypes.func.isRequired,
  onGenderChange: require('react').PropTypes.func.isRequired,
  onTitleChange: require('react').PropTypes.func.isRequired,
  onPasswordChange: require('react').PropTypes.func.isRequired,
  onPhoneChange: require('react').PropTypes.func.isRequired,
  onBirthdateDayChange: require('react').PropTypes.func.isRequired,
  onBirthdateMonthChange: require('react').PropTypes.func.isRequired,
  onBirthdateYearChange: require('react').PropTypes.func.isRequired,
  onClaimNumberChange: require('react').PropTypes.func.isRequired,
  onPolicyNumberChange: require('react').PropTypes.func.isRequired,
  onAddressLineChange: require('react').PropTypes.func.isRequired,
  onAddressCityChange: require('react').PropTypes.func.isRequired,
  onAddressPostcodeChange: require('react').PropTypes.func.isRequired,
  onVisitReasonChange: require('react').PropTypes.func.isRequired,
  onRequestAppointment: require('react').PropTypes.func.isRequired,
  submitAppointmentRequest: require('react').PropTypes.func.isRequired,
  updateAvailabilities: require('react').PropTypes.func.isRequired,
  validationError: require('react').PropTypes.func.isRequired,
  onTogglePolicyTermsAgreement: require('react').PropTypes.func.isRequired,
  onEmployeeIdChange: require('react').PropTypes.func.isRequired
};
RequestAppointmentModal.displayName = 'RequestAppointmentModal';

RequestAppointmentModal.defaultProps = {
  patient: {}
};

exports.default = RequestAppointmentModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/request-appointment-modal.js